import { render, staticRenderFns } from "./ListaCargadoresDialogComponent.vue?vue&type=template&id=2d30c526"
import script from "./ListaCargadoresDialogComponent.vue?vue&type=script&lang=js"
export * from "./ListaCargadoresDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports